import { DialogTitle } from "../shared/modal";
import {
  useSavedColors,
  useCmsDeleteColor,
} from "../../../js/api/my-saved-colors/get-saved-colors";
import { ErrorContent } from "../shared/error-content";
import { LoadingContent } from "../shared/loading-content";
import { LoggedInColorItem } from "./logged-in-color-item";

export function LoggedInColors() {
  const { data, isLoading, isError, isFetching } = useSavedColors();
  const isEmpty = !isLoading && !isFetching && !data?.items?.length;
  const deleteCmsColorMutation = useCmsDeleteColor();
  const onClearAllClick = () => {
    if (data?.clearAllAction?.linkUrl) {
      deleteCmsColorMutation.mutate({
        url: data?.clearAllAction.linkUrl,
      });
    }
  };

  if (isLoading) {
    return <LoadingContent />;
  }

  if (isError) {
    return <ErrorContent />;
  }

  return (
    <>
      <div className="saved-colors-header">
        <DialogTitle className="saved-colors-title saved-colors-title--position">
          {data?.modalLabel}
        </DialogTitle>
        {data?.clearAllAction && !isEmpty && (
          <button
            className="saved-colors-tertiary-action saved-colors-tertiary-action--position"
            type="button"
            onClick={onClearAllClick}
          >
            {data?.clearAllAction?.linkLabel}
          </button>
        )}
      </div>
      {isEmpty && (
        <div className="saved-colors-loading-container saved-colors-loading-container--no-top-padding">
          {data?.emptyStateText}
        </div>
      )}
      {!isEmpty && (
        <>
          <div className="saved-colors-main">
            <div className="saved-colors-grid">
              {data?.items?.slice(0, 20)?.map((color) => (
                <LoggedInColorItem
                  key={color.colourCode}
                  name={color.colourName}
                  rgb={color.colourRGB}
                  colourCode={color.colourCode}
                  colourActions={color.colourActions}
                  isTrending={color.isTrending}
                />
              ))}
            </div>
          </div>
          <div className="saved-colors-footer">
            {data?.secondaryAction && (
              <a
                className="saved-colors-action saved-colors-action--secondary"
                href={data?.secondaryAction.linkUrl}
              >
                {data?.secondaryAction?.linkLabel}
              </a>
            )}
            {data?.mainAction && (
              <a
                className="saved-colors-action saved-colors-action--main"
                href={data?.mainAction.linkUrl}
              >
                {data?.mainAction?.linkLabel}
              </a>
            )}
          </div>
        </>
      )}
    </>
  );
}
